import { createApp } from 'vue'
const CLASS_NAME_CATEGORY_ACCORDION = 'js-sectionsCategoryAccordion'
document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(
    CLASS_NAME_CATEGORY_ACCORDION
  )
  if (!elements.length) return
  Array.from(elements).forEach((element) => {
    createApp({
      name: 'SectionsCategoryAccordion',
      data() {
        return {
          selectedCategoryHandle: null,
        }
      },
      methods: {
        showAccordion(categoryHandle) {
          this.selectedCategoryHandle =
            this.selectedCategoryHandle === categoryHandle
              ? null
              : categoryHandle
        },
      },
    }).mount(element)
  })
})
